import {
  getBandLabelY,
  ShootTimeChartPadding,
  ShootTimeXScale,
} from "./layout";
import { ShootTimeBand } from "portal/utils/shootTime";
import { useTheme } from "@mui/material";
import React, { FunctionComponent } from "react";

/** Colored vertical bands (Small/Medium/Large, etc.) with size-range labels. */
export interface ShootTimeChartBandsProps {
  bands: ShootTimeBand[];
  chartPadding: ShootTimeChartPadding;
  plotHeight: number;
  xScale: ShootTimeXScale;
}

export const ShootTimeChartBands: FunctionComponent<
  ShootTimeChartBandsProps
> = ({ bands, chartPadding, plotHeight, xScale }) => {
  const {
    palette: {
      chart: { bandColors, bandLabelColor },
    },
  } = useTheme();

  return (
    <>
      {bands.map(({ bounds: { lower, upper }, label }, index) => {
        const bandCenterX = (xScale(lower) + xScale(upper)) / 2;
        const bandLabelY = getBandLabelY(chartPadding.top);
        return (
          <g key={`${lower}-${upper}`}>
            <rect
              x={xScale(lower)}
              y={chartPadding.top}
              width={Math.max(xScale(upper) - xScale(lower), 0)}
              height={plotHeight}
              fill={bandColors[index % bandColors.length]}
            />
            <text
              x={bandCenterX}
              y={bandLabelY}
              textAnchor="middle"
              dominantBaseline="hanging"
              fill={bandLabelColor}
              className="text-sm font-semibold"
            >
              {label}
            </text>
          </g>
        );
      })}
    </>
  );
};
